import { z } from 'zod'

import { moneySchema } from '@/schemas/common'

/**
 * Home's own read of the movers wire: one row of "Gaining most" or "Falling most".
 *
 * The same four facts Market Overview's pair draws (`moverBriefSchema` in
 * `src/schemas/market-overview.ts`) — symbol, name, price, change — so Home hands its rows to
 * that card's own `MoversList` and the two tables cannot drift apart. Read straight off
 * `marketEndpoints(client).movers()` rather than through `useMarketOverview()`, a ten-endpoint
 * fan-out for a two-list read; see `homeService.ts`.
 */
export const homeMoverRowSchema = z.object({
  symbol: z.string().min(1),
  name: z.string().min(1),
  ltp: moneySchema,
  percentChange: moneySchema,
})

export type HomeMoverRow = z.infer<typeof homeMoverRowSchema>
/** The two lists the Gainers and losers block draws side by side (pages revamp, 2026-10-27). */
export type HomeMoversSide = 'gainers' | 'losers'
